// extracted by mini-css-extract-plugin
export var closeButton = "custom-modal-module--close-button--NrEVD";
export var container = "custom-modal-module--container--vkPbU";
export var titleText = "custom-modal-module--title-text--RE1rr";
export var topImage = "custom-modal-module--top-image--t+QIC";